import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { ModalHelper } from '../../components/modal/modal.helper';
import { UtilsService } from '../../services/utils.service';
import { DatePipe } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
var HistoryComponent = (function () {
    function HistoryComponent(_data, _blogic, _utils, _modal, datePipe) {
        this._data = _data;
        this._blogic = _blogic;
        this._utils = _utils;
        this._modal = _modal;
        this.datePipe = datePipe;
        this.historyList = [];
        this.turn = {};
        this.modalLoaded = false;
        this.destroy$ = new Subject();
    }
    HistoryComponent.prototype.ngOnInit = function () {
        var self = this;
        $('#historyModal').on('hidden.bs.modal', function (e) {
            self.turn = {};
            self.historyList = [];
        });
    };
    HistoryComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    /* Get the paused turn list */
    HistoryComponent.prototype._getHistoryList = function (turn, id) {
        var _this = this;
        this.turn = turn;
        var params = {
            turn_id: turn.id
        };
        this._blogic.getAssist(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.historyList = response;
            _this._modal.show(id);
        });
        this.modalLoaded = true;
    };
    /* Open paused modal */
    HistoryComponent.prototype.openHistoryModal = function (turn, id) {
        this._getHistoryList(turn, id);
    };
    return HistoryComponent;
}());
export { HistoryComponent };
